export default __webpack_public_path__ + "static/media/NotFound.87a65aba.svg";